(function () {
  Flint.file("views/prmenu.js", function (require) {
    Flint.staticStyles("PRMenu", {
      "$hoverTarget": "#_flintapp hoverTarget.PRMenu, #_flintapp .PRMenu.hoverTarget, #_flintapp .ViewPRMenu.hoverTarget, #_flintapp .PRMenu > .hoverTarget",
      "$titleRow": "#_flintapp titleRow.PRMenu, #_flintapp .PRMenu.titleRow, #_flintapp .ViewPRMenu.titleRow, #_flintapp .PRMenu > .titleRow",
      "$expander": "#_flintapp expander.PRMenu, #_flintapp .PRMenu.expander, #_flintapp .ViewPRMenu.expander, #_flintapp .PRMenu > .expander",
      "$hoverBridge": "#_flintapp hoverBridge.PRMenu, #_flintapp .PRMenu.hoverBridge, #_flintapp .ViewPRMenu.hoverBridge, #_flintapp .PRMenu > .hoverBridge",
      "$menuOptions": "#_flintapp menuOptions.PRMenu, #_flintapp .PRMenu.menuOptions, #_flintapp .ViewPRMenu.menuOptions, #_flintapp .PRMenu > .menuOptions",
      "$menuOption": "#_flintapp menuOption.PRMenu, #_flintapp .PRMenu.menuOption, #_flintapp .ViewPRMenu.menuOption, #_flintapp .PRMenu > .menuOption"
    }, {
      "$hoverTarget": {
        position: 'relative'
      },
      "$titleRow": {
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer'
      },
      "$expander": {
        width: 24,
        height: 24
      },
      "$hoverBridge": {
        position: 'absolute',
        paddingTop: 4,
        zIndex: 10
      },
      "$menuOptions": {
        flexGrow: 1,
        alignItems: 'stretch',
        background: 'white',
        border: '1px solid #ddd',
        paddingTop: 6,
        paddingBottom: 6
      },
      "$menuOption": {
        alignSelf: 'stretch',
        padding: [6, 12],

        whiteSpace: 'nowrap'
      }
    });
    Flint.view("PRMenu", function (view, on, $) {
      var pro = initPro(view, {
        title: atom(),
        options: M.listAtom(),
        style: M.mergeAtom({
          menuWrapper: {}
        })
      });

      var showingMenu = atom(false);
      var hoveringIndex = atom(null);

      showingMenu.react(function (showingMenu) {
        if (showingMenu) {
          M.mixpanel.track('NavMenuHover', { title: pro.title.get() });
        }
      });view.render(function () {
        return view.el(
          ["hoverTarget", 1],
          {
            onMouseEnter: function () {
              return showingMenu.set(true);
            },
            onMouseLeave: function () {
              return showingMenu.set(false);
            }
          },
          view.el(
            ["titleRow", 1],
            null,
            view.el(
              ["titleSection", 1],
              null,
              pro.title.get()
            ),
            view.el(["img", 1], { className: "expander", src: "/images/triangleDown.png" })
          ),
          Flint.iff(showingMenu.get()) && view.el(
            ["hoverBridge", 1],
            { if: showingMenu.get(),
              style: pro.style.get().get('menuWrapper').toJS()
            },
            view.el(
              ["menuOptions", 1],
              null,
              Flint.range(pro.options.get()).map(function (_, _index) {
                return view.el(
                  ["NavLink", 1, _, _index],
                  { repeat: pro.options.get(),
                    to: _.url,
                    target: _.target,
                    style: {
                      alignSelf: 'stretch',
                      alignItems: 'stretch'
                    }
                  },
                  view.el(
                    ["menuOption", 1, _, _index],
                    {
                      onMouseEnter: function () {
                        return hoveringIndex.set(_index);
                      },
                      onMouseLeave: function () {
                        return hoveringIndex.set(null);
                      }
                    },
                    _.label
                  )
                );
              })
            )
          )
        );
      });

      $["menuOption"] = function (_, _index) {
        return { background: hoveringIndex.get() == _index ? '#f6f6f6' : null };
      };
    });
  })
})();
//# sourceMappingURL=prmenu.js.map
